import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import firebase from "./plugins/firebase";
import DashboardPlugin from "./plugins/dashboard-plugin";
import MapboxPlugin from "./plugins/mapbox-cdn";
import store from "./store";
import "dotenv/config"; // Import the functions you need from the SDKs you need

// filepath: /Users/parkerbrown/wol/wade-o-lution-front/src/main.js
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
// filepath: /Users/parkerbrown/wol/wade-o-lution-front/src/main.js
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

// Create a global event bus
export const EventBus = new Vue();

// Photoswipe Gallery
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);
Vue.use(firebase);
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(MapboxPlugin);

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");